import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBInputGroup,
  MDBDatepicker,
  MDBSelect,
  MDBDatatable,
  MDBIcon, MDBTextArea,
  MDBPopconfirm, MDBPopconfirmMessage,
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,
  MDBBadge, MDBTable, MDBTableHead, MDBTableBody

} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'
import Favoriteitem from './sub/favoriteitem'
import Billlist from './sub/billlist'
import { v4 as uuidv4 } from 'uuid';


const Component = () => {

  const { state } = useLocation();
  let { name } = useParams();
  const error = useRef();
  const setError = (message) => error.current.showerror(message);

  const editjob = useRef();
  const [isFinalize, setIsFinalize] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);

  const [selectedrow, setSelectedRow] = useState(null);
  const [summarydata, setSummarydata] = useState({});
  const [transportAccount, setTransportAccount] = useState({});
  const [transportJobList, setTransportJobList] = useState([]);
  const [transportExpenseList, setTransportExpenseList] = useState([]);

  const [billitem, setBillitem] = useState([]);
  const [selectpaidby, setselectpaidby] = useState(1);



  const [paidbylist, setpaidbylist] = useState([
    { text: 'บริษัท', value: 1 },
    { text: 'เครดิต', value: 2 },
    { text: 'เงินสด', value: 3 }
  ]);
  const [resultData, setResultData] = useState({
    columns: [
      { label: "ใบงาน", field: 'name', sort: false },
      { label: "วันที่ / เวลา", field: 'jobdate', sort: false },
      { label: "วันครบกำหนด", field: 'duedate', sort: false },
      { label: "สถานะ", field: 'status', sort: false },
      { label: "ผู้ว่าจ้าง", field: 'customername', sort: false },
      { label: "จำนวนงาน", field: 'jobcount', sort: false },
      { label: "จ่าย", field: 'paidby', sort: false },
      { label: "ผู้แก้ไขข้อมูล", field: 'modify_name', sort: false },
      { label: "", field: 'action', sort: false }

    ],
    rows: []
  });
  const [datatableKey, setDatatableKey] = useState(0);
  const [resultDataExpense, setResultDataExpense] = useState({
    columns: [
      { label: "เลขที่เอกสาร", field: 'name', sort: false },
      { label: "วันที่ / เวลา", field: 'jobdate', sort: false },
      { label: "วันวางบิล", field: 'billdate', sort: false },
      { label: "วันครบกำหนด", field: 'duedate', sort: false },
      { label: "ลูกค้า", field: 'customername', sort: false },
      { label: "ค่าเที่ยว", field: 'travel', sort: false },
      { label: "ค่าทางด่วน", field: 'toll', sort: false },
      { label: "ค่าปะยาง", field: 'tire', sort: false },
      { label: "ค่าฝากตู้", field: 'boxdeposit', sort: false },
      { label: "ซ่อมรถ", field: 'fixservice', sort: false },
      { label: "ค่าน้ำมัน", field: 'gas', sort: false },
      { label: "", field: 'action', sort: false },

    ],
    rows: []
  });
  const approve = async (e) => {
    e.preventDefault();
    if (transportJobList.length == 0) { setError("ไม่มีข้อมูล"); return; }
    setIsLoading(true);
    try {

      transportAccount.duedate = document.getElementById("duedate").value;
      transportAccount.billdate = document.getElementById("billdate").value;
      transportAccount.remark = document.getElementById("remark").value;
      transportAccount.summarydata = summarydata;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransportAccount`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transportAccount, transportJobList, approve: true }),
      });
      const data = await response.json();
      if (response.ok) {
        setTransportAccount(data.transportAccount);
        setTransportJobList([...data.transportJobList]);

        error.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว")
        setIsFinalize(data.transportAccount.statusid == 3 ? true : false);
      } else {

        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
    finally {
      // Reset loading state
      setIsLoading(false);
    }

  };

  const approveandprint = async (e, link, target) => {
    if (!isFinalize)
      await approve(e);
    window.open(link, target)
  };


  const saveandprint = async (e, link, target) => {
    await saveData(e);
    window.open(link, target)
  };

  const saveData = async (e) => {
    e.preventDefault();
    if (transportJobList.length == 0) { setError("ไม่มีข้อมูล"); return; }
    setIsLoading(true);
    try {

      transportAccount.duedate = document.getElementById("duedate").value;
      transportAccount.billdate = document.getElementById("billdate").value;
      transportAccount.remark = document.getElementById("remark").value;
      transportAccount.summarydata = summarydata;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransportAccount`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transportAccount, transportJobList }),
      });
      const data = await response.json();
      if (response.ok) {
        setTransportAccount(data.transportAccount);
        setTransportJobList([...data.transportJobList]);

        error.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว")
      } else {

        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
    finally {
      // Reset loading state
      setIsLoading(false);
    }

  }
  const navigate = useNavigate();

  const getTransportAccount = async (transportname) => {

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccount/${transportname}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (!data.transportAccount) {
          setError('ไม่มีข้อมูลการขนส่ง');
          return;
        }

        setSummarydata({
          totalamount: data.transportAccount.totalamount,
          totalnetamount: data.transportAccount.totalnetamount,
          totalvatamount: data.transportAccount.totalvatamount,
          totalwhtamount: data.transportAccount.totalwhtamount,
          totalpaidamount: data.transportAccount.totalpaidamount
        });
        setTransportAccount(data.transportAccount);
        setselectpaidby(data.transportAccount.paidbyid)
        getTransportJobList(data.transportAccount.id);
        fetchTransport_expenseList(null, null, transportname)
        setIsFinalize(data.transportAccount.statusid == 3 ? true : false);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }

  const fetchTransport_expenseList = async (dateFrom, dateTo, search) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccountList_expense`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo, search }),

      });

      if (response.ok) {
        const data = await response.json();
        setTransportExpenseList(data.transportJobList);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  };

  const getTransportJobList = async (transportid) => {


    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportJobListById/${transportid}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setTransportJobList(data.transportJobList);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }

  const unapprove = async () => {


    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/revertTransportAccount/${transportAccount.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        transportAccount.statusid == 2
        setIsFinalize(false);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }



  const getBillitem = async () => {


    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getBillitem`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setBillitem(data.result);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }

  useEffect(() => {
    // Get the token from sessionStorage


    if (!["accountant", "billing", "admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }
    getTransportAccount(name);
    getBillitem();


  }, []);

  useEffect(() => {

    generateTreeExpense(transportExpenseList);

  }, [transportExpenseList]);

  const addduedate = (duration) => {
    var currentduedate = document.getElementById("billdate").value;
    currentduedate = moment(currentduedate, "DD/MM/YYYY").add(duration, "days");
    document.getElementById("duedate").value = currentduedate.format("DD/MM/YYYY");
  }

  const endEdit = () => {



  }
  const editRow = (row) => {

    setBasicModal(true);
    setSelectedRow({ row });

  }
  const deleteRow = (row) => {



  }

  const updatesummary = (bills) => {
    var summarydata = { totalamount: 0, totalwhtamount: 0, totalvatamount: 0, totalnotbillamount: 0, totalnotbillwhtamount: 0, totalnotbillvatamount: 0 }
    transportJobList.forEach(row => {
      row.bills.filter(e => e.isbillitem == 1).forEach(bill => {

        summarydata.totalamount += parseFloat(bill.totalamount ? bill.totalamount : 0);
        summarydata.totalwhtamount += parseFloat(bill.whtamount ? bill.whtamount : 0);
        summarydata.totalvatamount += parseFloat(bill.vatamount ? bill.vatamount : 0);
      });

      row.bills.filter(e => e.isbillitem == 0).forEach(bill => {

        summarydata.totalnotbillamount += parseFloat(bill.totalamount ? bill.totalamount : 0);
        summarydata.totalnotbillwhtamount += parseFloat(bill.whtamount ? bill.whtamount : 0);
        summarydata.totalnotbillvatamount += parseFloat(bill.vatamount ? bill.vatamount : 0);

      });

    });
    if (summarydata.totalnotbillamount != 0) {
      summarydata.totalnotbillnetamount = summarydata.totalnotbillvatamount + summarydata.totalnotbillamount;
      summarydata.totalnotbillpaidamount = summarydata.totalnotbillnetamount - summarydata.totalnotbillwhtamount;
    }

    summarydata.totalnetamount = summarydata.totalvatamount + summarydata.totalamount;
    summarydata.totalpaidamount = summarydata.totalnetamount - summarydata.totalwhtamount;

    setSummarydata(summarydata);
  }
  const addtoall = (item) => {

    transportJobList.forEach(row => {
      var bill = { ...item };
      delete bill.rowid;
      var bills = [];
      if (row.bills) bills = Object.assign([], row.bills)

      if (item.isaddheader) {
        bill.item = `${item.text} ${row.pickuplocation ?? ""}>${row.destination ?? ""} ${moment(row.jobdate).format("DD/MM/YYYY")} ${row.boxno} (${row.lcplate})`
      }
      else {
        bill.item = item.text;
      }
      bill.id = uuidv4();
      bill.transport_listid = row.id,
        bill.totalamount = bill.amount * bill.qty;
      bill.vatamount = !bill.vat ? 0 : bill.amount * bill.qty * bill.vat / 100;
      bill.whtamount = !bill.wht ? 0 : bill.amount * bill.qty * bill.wht / 100;
      bills.push(bill);
      row.bills = [...bills];
    })

    setTransportJobList([...transportJobList]);
  }



  const generateTable = (transportJobList) => {
    return (<MDBTableBody>
      {transportJobList.map((row, i) => {
        if (!(row.bills)) row.bills = [];
        return (
          <React.Fragment key={i}>
            <tr key={i}>
              <td>{row?.jobdate ? moment(row?.jobdate).format("DD/MM/YYYY") : ""}</td>
              <td>{row?.jobname}</td>
              <td>{row?.pickuplocation}</td>
              <td>{row?.destination}</td>
              <td>{row?.bl}</td>
              <td>{row?.amount}</td>
              <td>{row?.boxsize}</td>
              <td>{row?.boxno}</td>
              <td>{row?.returnboxduration}</td>
              <td>{row?.returnboxdestination}</td>
              <td>{row?.driver}</td>
              <td>{row?.lcplate}</td>
            </tr>
            <tr key={"bill" + i}>
              <td colSpan={12}>
                <Billlist Row={row} key={"billgrid" + i} index={"billgrid" + i} items={billitem} updateparent={updatesummary} />
              </td>
            </tr>
          </React.Fragment>)
      }
      )}

    </MDBTableBody>);
  }

  const generateTreeExpense = (item) => {
    var main = item.map((row) => {
      return {
        ...row,
        jobdate: moment(row.jobdateobj).format("DD/MM/YYYY HH:mm"),
        duedate: row.duedateobj ? moment(row.duedateobj).format("DD/MM/YYYY") : "",
        billdate: row.billdateobj ? moment(row.billdateobj).format("DD/MM/YYYY") : "",
        action: (
          <>

            {/* <>   {row.transportname && <MDBBtn outline size='sm' floating className='call-btn' onClick={() => window.open('/TransportAccount/' + row.transportname, '_blank')}>
              {row.statusid != 3 ? <MDBIcon icon='pen' /> : <MDBIcon icon='eye' />}
            </MDBBtn>}
            </> */}
            <>   {<MDBBtn outline size='sm' floating className='call-btn' onClick={() => window.open('/TransportAccount_Expense/' + row.name, '_blank')}>
              {row.statusid != 3 ? <MDBIcon icon='pen' /> : <MDBIcon icon='eye' />}
            </MDBBtn>}
            </>
            <>   {row.transportname && <MDBBtn outline size='sm' rounded color='info' className='call-btn' onClick={() => window.open('/Print/ExpenseTawi50/' + row.name + '?personal=1', '_blank')}>
              <MDBIcon icon='print' />{" ทวิ 50 (บุคคล)"}
            </MDBBtn>}
            </>

          </>
        )

      }
    });



    var _resultData = {

      rows: main
    }

    _resultData.columns = [...resultDataExpense.columns];

    setResultDataExpense(_resultData);
    setDatatableKey((prevKey) => prevKey + 1);

  }


  return (<>
    <Navbar />
    <MDBContainer fluid className="my-3">
      <Alert ref={error} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">
            <MDBCardHeader>
              <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                <MDBCol md='6'>
                  <h4>{transportAccount.name ? `ข้อมูลบัญชีขนส่ง (${transportAccount.name} - วันที่เอกสาร ${moment(transportAccount?.jobdateobj).format('DD/MM/YYYY  HH:mm')})` : "ลงข้อมูลบัญชีขนส่ง"}</h4>
                </MDBCol>
                <MDBCol md={isFinalize ? 6 : 4}>
                  <div className='d-flex flex-row-reverse me-3'>
                    {!isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={(e) => saveandprint(e, `/Print/Bill/` + transportAccount.name, '_blank')} disabled={isLoading}>พิมพ์ใบวางบิล</MDBBtn>
                    </div>}

                    {/* {isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={() => window.open(`/Print/50Tawi/` + transportAccount.name, '_blank')} disabled={isLoading}>พิมพ์ทวิ50</MDBBtn>
                    </div>} */}

                    {isFinalize && ["billing", "admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={(e) => approveandprint(e, `/Print/Receipt/` + transportAccount.name, '_blank')} disabled={isLoading}>พิมพ์ใบแจ้งหนี้</MDBBtn>
                    </div>}
                  </div>
                </MDBCol>
                <MDBCol md='1'>

                  {!isFinalize && ["billing", "admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='success' onClick={approve} disabled={isLoading}>อนุมัติ</MDBBtn>
                  </div>}

                  {isFinalize && ["admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='danger' onClick={unapprove} disabled={isLoading}>ยกเลิกอนุมัติ</MDBBtn>
                  </div>}

                </MDBCol>
                <MDBCol md='1'>

                  {!isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
                  </div>}
                </MDBCol>
              </MDBRow>


            </MDBCardHeader>
            <MDBCardBody>

              <MDBRow className="mt-3">
                             {(transportAccount?.transportbill_name || transportAccount?.transportreceipt_name || transportAccount?.receiptname) && <>
                <MDBCol md="7">
                   <MDBInputGroup textBefore='เลขเอกสารใบวางบิล' className='mb-3'>
                    <input className='form-control' type='text'  defaultValue={transportAccount?.transportbill_name} readOnly />
                    <span className='input-group-text'>เลขเอกสารรวมใบเสร็จ</span>
                    <input className='form-control' type='text' defaultValue={transportAccount?.transportreceipt_name} readOnly />
                        <span className='input-group-text'>เลขใบเสร็จ</span>
                    <input className='form-control' type='text' defaultValue={transportAccount?.receiptname} readOnly />
                  </MDBInputGroup>
                </MDBCol>  <MDBCol md="5"> </MDBCol>
              </>}
                <MDBCol md="5">

                  <MDBInputGroup textBefore='ลูกค้า' className='mb-3'>
                    <input className='form-control' type='text' id={"driver"} defaultValue={transportAccount?.customername} readOnly />
                    <span className='input-group-text'>เลขภาษี</span>
                    <input className='form-control' type='text' id={"driver"} defaultValue={transportAccount?.tax} readOnly />
                  </MDBInputGroup>

                </MDBCol>
                <MDBCol md="2">

                  <MDBInputGroup textBefore='จ่าย' className='mb-3 dropdown-group'>
                    <MDBSelect
                      data={paidbylist}
                      value={selectpaidby}
                      onChange={(e) => {
                        setselectpaidby(e.value);
                      }}
                    />
                  </MDBInputGroup>

                </MDBCol>

                <MDBCol md="5">

                  <MDBInputGroup textBefore='วันวางบิล' className='mb-3 dropdown-group'>
                    <MDBDatepicker inputToggle inline id={"billdate"} inputLabel="วันวางบิล" onChange={(value) => transportAccount.billdate = value} value={transportAccount?.billdate ? transportAccount?.billdate : (transportAccount?.billdateobj ? moment(transportAccount?.billdateobj).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'))} />
                    <span className='input-group-text'>วันครบกำหนด</span>
                    <MDBDatepicker inputToggle inline id={"duedate"} inputLabel="วันครบกำหนด" onChange={(value) => { transportAccount.duedate = value }} value={transportAccount?.duedate ? transportAccount?.duedate : (transportAccount?.duedateobj ? moment(transportAccount?.duedateobj).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'))} />
                    <MDBBtn outline color='dark' onClick={() => addduedate(3)}>+3 วัน</MDBBtn>
                    <MDBBtn outline color='dark' onClick={() => addduedate(7)}>+7 วัน</MDBBtn>
                    <MDBBtn outline color='dark' onClick={() => addduedate(30)}>+30 วัน</MDBBtn>
                  </MDBInputGroup>

                </MDBCol>
                <MDBCol md="12">
                  <MDBTextArea
                    label="หมายเหตุ"
                    id={"remark"}
                    name="remark"
                    defaultValue={transportAccount.remark}
                    className="mb-3"
                    rows={2}
                  />
                </MDBCol>
                <MDBCol md="12">

                  <MDBInputGroup textBefore='สรุป' className='mb-3 '>
                    <span className='input-group-text'>มูลค่าไม่รวมภาษี {summarydata?.totalamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    {summarydata?.totalvatamount != 0 &&
                      <span className='input-group-text'>ภาษีมูลค่าเพิ่ม 7% {summarydata?.totalvatamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    }
                    <span className='input-group-text'>จำนวนเงินที่ถูกหัก ณ ที่จ่าย {summarydata?.totalwhtamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    <span className='input-group-text'>จำนวนเงินที่ชำระ  {summarydata?.totalpaidamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    <span className='input-group-text'><b>จำนวนเงินทั้งสิ้น  {summarydata?.totalnetamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</b></span>
                    <span className='input-group-text ms-2'>จำนวนที่ไม่เรียกเก็บ  {summarydata?.totalnotbillamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                  </MDBInputGroup>

                </MDBCol>

                {billitem && billitem.length > 0 && billitem.filter(e => e.canaddtoall == 1).map((item, i) => (<Favoriteitem key={i} item={item} callback={addtoall} />))}
              </MDBRow>
              <div className='d-flex align-items-center h-100'>

                <MDBTable striped small className=''>
                  <MDBTableHead>
                    <tr>
                      <th scope='col'>วันที่</th>
                      <th scope='col'>งาน</th>
                      <th scope='col'>สถานที่รับ</th>
                      <th scope='col'>ปลายทาง</th>
                      <th scope='col'>BL</th>
                      <th scope='col'>จำนวน</th>
                      <th scope='col'>ขนาด</th>
                      <th scope='col'>เบอร์ตู้</th>
                      <th scope='col'>คืนตู้ภายใน</th>
                      <th scope='col'>สถานที่คืนตู้</th>
                      <th scope='col'>คนรถ</th>
                      <th scope='col'>ทะเบียน</th>
                    </tr>
                  </MDBTableHead>

                  {transportJobList && transportJobList.length > 0 && generateTable(transportJobList)}

                </MDBTable>
               
              </div>
               <div className="mt-2">
                <h5>รายการบันทึกค่าใช้จ่าย</h5>
                <MDBDatatable hover key={datatableKey} data={resultDataExpense} rowsText="แสดง" noFoundMessage="ไม่มีข้อมูล" ofText="จาก" allText="ทั้งหมด" />
              </div>
              {!isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
              </div>}
            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>




      <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
        <MDBModalDialog centered size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>แก้ไขข้อมูลงาน</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {selectedrow && <JobDetail setError={setError} customers={customers} ref={editjob} job={selectedrow.row} mode="edit" disabledCustomer={transportJobList.length > 0} />}

            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={toggleOpen}>
                ปิด
              </MDBBtn>
              <MDBBtn onClick={endEdit}>บันทึก</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </MDBContainer>
  </>
  );
};

export default Component;
